import React from 'react'
import { Icon, Button, TruncatedText } from '@pandiafi/design-system'
import classNames from 'classnames'

interface FileLinkProps {
  name: string
  onClick: () => void
  className?: string
  loading?: boolean
}

export const FileLink: React.FC<FileLinkProps> = ({
  name,
  onClick,
  className,
  loading = false,
}) => {
  return (
    <div className={classNames(className, 'flex items-center')}>
      <FixedSizeIcon />
      <Button
        variant="text"
        text
        className="underline font-medium max-w-full"
        onClick={onClick}
        loading={loading}
        disabled={loading}
      >
        <TruncatedText truncateType="width">{name}</TruncatedText>
      </Button>
    </div>
  )
}

const FixedSizeIcon: React.FC = () => (
  <div className="size-8 flex justify-center items-center">
    <Icon variant="balloon" icon="paperclip" />
  </div>
)
